type ParamWithYValue = {
  data?: { value?: [number, number] };
  value?: number;
};

/**
 * Given tooltip params that all share the same x-axis position, returns the
 * param whose Y data-value is closest to cursorDataY.
 *
 * cursorDataY should be obtained by a capture-phase mousemove listener that
 * calls chart.convertFromPixel({ gridIndex: 0 }, [clientX, clientY])[1] so
 * the ref is populated before the ECharts tooltip formatter runs.
 *
 * Returns undefined when candidates is empty, otherwise always returns one
 * item — falling back to candidates[0] when cursorDataY is null (cursor
 * outside the grid) or only one candidate exists.
 */
export function findNearestSeriesByY<T extends ParamWithYValue>(
  candidates: T[],
  cursorDataY: number | null,
): T | undefined {
  if (candidates.length === 0) return undefined;
  if (cursorDataY == null || candidates.length === 1) return candidates[0];
  let nearest = candidates[0];
  let minDist = Infinity;
  for (const p of candidates) {
    const y = p.data?.value?.[1] ?? p.value;
    if (y == null) continue;
    const dist = Math.abs(y - cursorDataY);
    if (dist < minDist) {
      minDist = dist;
      nearest = p;
    }
  }
  return nearest;
}
